module.exports = __webpack_public_path__ + "static/media/FINLAND.a5471749.svg";